import gql from 'graphql-tag';
import FieldsEmployee from "graphql/fields/FieldsEmployee";
import FieldsDepartment from "graphql/fields/FieldsDepartment";
import FieldsJobtitle from "graphql/fields/FieldsJobtitle";
import HelperGraphql from 'utils/helper-graphql'
import VariablesPagination from 'graphql/variables/VariablesPagination'

const fields = {
	'team_guid': 'String',
	'visible_for_employees': '[String]',
	'verified': '[String]',
	'active': '[String]',
	'search': 'String',
	...VariablesPagination
};

export default gql(`
	query employees( ${ HelperGraphql.createFields( fields ) } )  {
		employees( ${ HelperGraphql.createVariables( fields ) } )  {
			${FieldsEmployee}
			verified
			
			department {
				${FieldsDepartment}
			}
			
			jobtitle {
				${FieldsJobtitle}
			}
		}
	}
`);

